import React from "react";
import { Row, Col,  NavItem, Nav, NavLink } from "reactstrap";
import { connect } from "react-redux";
import QuestionElements from "../../../elements/list/QuestionElements/QuestionElements";
import FieldElements from "../../../elements/list/FieldElements/FieldElements";
import EventElements from "../../../elements/list/EventElements/EventElements";
import ContainerElements from "../../../elements/list/ContainerElements/ContainerElements";
import ContentElements from "../../../elements/list/ContentElements/ContentElements";
import PaymentElements from "../../../../cms/elements/list/PaymentElements/PaymentElements";
import PreConfirmationsElements from "../../../elements/list/PreConfirmationElements/PreConfirmationsElements";
import RateReviewIcon from "@material-ui/icons/RateReview";
import WidgetsIcon from "@material-ui/icons/Widgets";
import "./ElementsTab.css";
import { sourceTypes } from "../../../../constants/cms/sourceType";
import SystemLabel from "../../../../system/SystemLabel/SystemLabel";
import UserPageElements from "../../../elements/list/UserPageElements/UserPageElements";
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import EmailIcon from '@material-ui/icons/Email';
import { EmailElements } from "../../../areas/email/elementGroups/EmailElements";


class ElementsTab extends React.Component {
  state = {
    activeTab: "Content",
    hideContent: false
  };
  componentDidMount() {
    if (this.props.env !== undefined &&
      this.props.env === sourceTypes.EMAIL) {
      this.setState({ activeTab: 'Email' })
    }
  }
  componentDidUpdate(prevProps) {
    if (this.props.env !== undefined &&
      prevProps.env !== this.props.env &&
      this.props.env === sourceTypes.EMAIL) {
      this.setState({ activeTab: 'Email' })
    }
  }
  toggleTab = area => {
    if (area === this.state.activeTab) {
      if (!this.state.hideContent) {
        this.setState({ activeTab: "", hideContent: true });
      }
    } else {
      this.setState({ activeTab: area, hideContent: false });
    }
  };
  render() {
    const { activeTab } = this.state;
    const { env } = this.props;
    return (
      <div style={{ display: "inline-flex", marginTop: "-14px" }}>
        <div
          className="element-list-nav"
          style={{
            height:
              env === sourceTypes.FORM
                ? "calc(100vh - 135px)"
                : "calc(100vh - 94px)"
          }}
        >
          <Row style={{ margin: "0px" }}>
            <Col style={{ padding: "0px" }}>
              <Nav vertical className="editor-nav-aside-list" tabs>
                {env === sourceTypes.FORM ? (
                  <React.Fragment>
                    {!this.props.form.survey ? <React.Fragment ><NavItem
                      className={`${
                        activeTab === "Events" ? "content-active" : ""
                        }`}
                    >
                      <NavLink className={`${
                        activeTab === "Events" ? "content-active" : ""
                        }`} onClick={() => this.toggleTab("Events")}>
                        <i className="fa fa-calendar  tab-icon" />
                        <br />
                        <div
                          style={{
                            fontWeight: "600",
                            fontSize: "8px",
                            textTransform: "uppercase",
                            borderBottom: "0px !important",
                            wordBreak: "break-all",
                            marginTop: '3px'
                          }}
                        >
                          <SystemLabel name="EventElements" />
                        </div>
                      </NavLink>
                    </NavItem>

                      <NavItem
                        className={`${
                          activeTab === "Fields" ? "content-active" : ""
                          }`}
                      >
                        <NavLink className={`${
                          activeTab === "Fields" ? "content-active" : ""
                          }`} onClick={() => this.toggleTab("Fields")}>
                          <i className="fa fa-user tab-icon" />
                          <br />
                          <div
                            style={{
                              fontWeight: "600",
                              fontSize: "8px",
                              textTransform: "uppercase",
                              borderBottom: "0px !important",
                              wordBreak: "break-all",
                              marginTop: '3px'
                            }}
                          >
                            <SystemLabel name="PersonFields" />
                          </div>
                        </NavLink>
                      </NavItem>
                    </React.Fragment> : null}

                    <NavItem
                      className={`${
                        activeTab === "Question" ? "content-active" : ""
                        }`}
                    >
                      <NavLink className={`${
                        activeTab === "Question" ? "content-active" : ""
                        }`} onClick={() => this.toggleTab("Question")}>
                        <i className="fa fa-question-circle tab-icon" />
                        <br />
                        <div
                          style={{
                            fontWeight: "600",
                            fontSize: "8px",
                            textTransform: "uppercase",
                            borderBottom: "0px !important",
                            wordBreak: "break-all",
                            marginTop: '3px'
                          }}
                        >
                          <SystemLabel name="QuestionElements" />
                        </div>
                      </NavLink>
                    </NavItem>
                    {!this.props.form.survey ? <React.Fragment>   <NavItem
                      className={`${
                        activeTab === "Payment" ? "content-active" : ""
                        }`}
                    >
                      <NavLink
                        className={`${
                          activeTab === "Payment" ? "content-active" : ""
                          }`}
                        onClick={() => this.toggleTab("Payment")}
                      >
                        <i className="fa fa-credit-card  tab-icon" />
                        <br />
                        <div
                          style={{
                            fontWeight: "600",
                            fontSize: "8px",
                            textTransform: "uppercase",
                            borderBottom: "0px !important",
                            wordBreak: "break-all",
                            marginTop: '3px'
                          }}
                        >
                          <SystemLabel name="Payment" />
                        </div>
                      </NavLink>
                    </NavItem>
                      <NavItem
                        className={`${
                          activeTab === "PreConfirmation" ? "content-active" : ""
                          }`}
                      >
                        <NavLink
                          className={` ${
                            activeTab === "PreConfirmation" ? "content-active" : ""
                            }`}
                          onClick={() => this.toggleTab("PreConfirmation")}
                        >
                          <RateReviewIcon
                            style={{ padding: "0px" }}
                            className=" tab-icon"
                          />
                          <br />
                          <div
                            style={{
                              fontWeight: "600",
                              fontSize: "8px",
                              textTransform: "uppercase",
                              borderBottom: "0px !important",
                              wordBreak: "break-all",
                              marginTop: '3px'
                            }}
                          >
                            <SystemLabel name="RegElements" />
                          </div>
                        </NavLink>
                      </NavItem> </React.Fragment> : null}
                  </React.Fragment>
                ) : null}
                {env !== sourceTypes.EMAIL ? <React.Fragment>
                  <NavItem
                    className={`${
                      activeTab === "Containers" ? "content-active" : ""
                      }`}
                  >
                    <NavLink className={`${
                      activeTab === "Containers" ? "content-active" : ""
                      }`} onClick={() => this.toggleTab("Containers")}>
                      <i className="fa fa-columns tab-icon" />
                      <br />
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "8px",
                          textTransform: "uppercase",
                          borderBottom: "0px !important",
                          wordBreak: "break-all",
                          marginTop: '3px'
                        }}
                      >
                        <SystemLabel name="Columns" />
                      </div>
                    </NavLink>
                  </NavItem>
                  <NavItem
                    className={`${
                      activeTab === "Content" ? "content-active" : ""
                      }`}
                  >
                    <NavLink
                      className={` ${
                        activeTab === "Content" ? "content-active" : ""
                        }`}
                      onClick={() => this.toggleTab("Content")}
                    >
                      <WidgetsIcon
                        style={{ padding: "0px" }}
                        className="tab-icon"
                      />
                      <br />
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "8px",
                          textTransform: "uppercase",
                          borderBottom: "0px !important",
                          wordBreak: "break-all",
                          marginTop: '3px'
                        }}
                      >
                        <SystemLabel name="ContentElementOpt" />
                      </div>
                    </NavLink>
                  </NavItem>
                </React.Fragment> : null}
                {env === sourceTypes.PAGE ?

                  <NavItem
                    className={`${
                      activeTab === "UserPage" ? "content-active" : ""
                      }`}
                  >
                    <NavLink
                      className={` ${
                        activeTab === "UserPage" ? "content-active" : ""
                        }`}
                      onClick={() => this.toggleTab("UserPage")}
                    >
                      <AccountBoxIcon
                        style={{ padding: "0px" }}
                        className="tab-icon"
                      />
                      <br />
                      <div
                        style={{
                          fontWeight: "600",
                          fontSize: "8px",
                          textTransform: "uppercase",
                          borderBottom: "0px !important",
                          wordBreak: "break-all",
                          marginTop: '3px'
                        }}
                      >
                        <SystemLabel name="UserPage" />
                      </div>
                    </NavLink>
                  </NavItem> : null
                }
                {env === sourceTypes.EMAIL ?
                  <React.Fragment>
                    <NavItem
                      className={`${
                        activeTab === "Email" ? "content-active" : ""
                        }`}
                    >
                      <NavLink
                        className={` ${
                          activeTab === "Email" ? "content-active" : ""
                          }`}
                        onClick={() => this.toggleTab("Email")}
                      >
                        <EmailIcon
                          style={{ padding: "0px" }}
                          className="tab-icon"
                        />
                        <br />
                        <div
                          style={{
                            fontWeight: "600",
                            fontSize: "8px",
                            textTransform: "uppercase",
                            borderBottom: "0px !important",
                            wordBreak: "break-all",
                            marginTop: '3px'
                          }}
                        >
                          <SystemLabel name="Email" />
                        </div>
                      </NavLink>
                    </NavItem>
                  </React.Fragment> : null}
              </Nav>
            </Col>
          </Row>
        </div>
        <div
          className="element-tab-content"
          style={{
            maxHeight:
              env === sourceTypes.FORM
                ? "calc(100vh - 135px)"
                : "calc(100vh - 94px)"
          }}
        >
          {activeTab && (
            <Col style={{ padding: "0px" }}>
              <div>
                {activeTab === "Events" && !this.state.isSurvey && (
                  <EventElements />
                )}
                {activeTab === "Fields" && !this.state.isSurvey && (
                  <FieldElements />
                )}
                {activeTab === "Question" && <QuestionElements />}
                {activeTab === "Containers" && <ContainerElements />}
                {activeTab === "Content" && <ContentElements />}
                {activeTab === "Payment" && <PaymentElements />}
                {activeTab === "PreConfirmation" && (
                  <PreConfirmationsElements />
                )}
                {activeTab === "Email" && (
                  <EmailElements />
                )}
                {activeTab === "UserPage" && (
                  <UserPageElements />
                )}
              </div>
            </Col>
          )}
        </div>
      </div >
    );
  }
}

function mapStateToProps(state) {
  return {
    env: state.cms.enviroment,
    form: state.form
  };
}
export default connect(mapStateToProps)(ElementsTab);
